var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"button text-nowrap",class:_vm.className,attrs:{"type":_vm.buttonType,"data-disabled":_vm.disabled,"data-cancel":_vm.isCancel}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }